import { render } from "./AttendeesPerEventDateTable.vue?vue&type=template&id=bb6c1d70"
import script from "./AttendeesPerEventDateTable.vue?vue&type=script&lang=js"
export * from "./AttendeesPerEventDateTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__